import React, { useState, useEffect } from "react";
import Button from "../../utils/Buttons";
import { useNavigate, useLocation } from "react-router-dom";
import { getClinicListApi } from "../../api/clinicService";
import { addAdminApi } from "../../api/addAdminService";
const AddAdmin = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const userId = location.state?.userId;
  const [clinicList, setClinicList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    fullName: "",
    email: "",
    mobileCountryCode: "+91",
    clinics: "",
    gender: "MALE",
    user: userId,
  });
  useEffect(() => {
    if (userId) {
      loadClinics(userId);
    }
  },[userId]);
  const loadClinics = async (userId) => {
    try {
      const res = await getClinicListApi(userId);
      setClinicList(res?.data || []);
    } catch (error) {
      console.log("Clinic fetch error:", error);
    }
  };
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };
  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      setLoading(true);
      const payload = {
        ...formData,
        clinics: formData.clinics ? [formData.clinics] : [],
      };
      await addAdminApi(payload);
      navigate("/user/clinics/view");
    } catch (error) {
      console.log("Add admin error:", error);
    } finally {
      setLoading(false);
    }
  };
  return (
    <div className="container mt-4">
      <h5>Add New Admin</h5>
      <div className="card shadow p-4">
        <form onSubmit={handleSubmit}>
          <div className="row">
            <div className="mb-3 col-md-6">
              <label>
                Full Name<span className="error">*</span>
              </label>
              <input
                type="text"
                name="fullName"
                placeholder="Enter Full Name"
                className="form-control"
                value={formData.fullName}
                onChange={handleChange}
                required
              />
            </div>
            <div className="mb-3 col-md-6">
              <label>
                Email<span className="error">*</span>
              </label>
              <input
                type="email"
                name="email"
                placeholder="Enter Email"
                className="form-control"
                value={formData.email}
                onChange={handleChange}
                required
              />
            </div>
          </div>
          <div className="row">
            <div className="mb-3 col-md-4">
              <label>
                Mobile<span className="error">*</span>
              </label>
              <input
                type="text"
                name="mobileCountryCode"
                placeholder="Enter Number"
                className="form-control"
                value={formData.mobileCountryCode}
                onChange={handleChange}
                required
              />
            </div>
            <div className="mb-3 col-md-4">
              <label>
                Clinics<span className="error">*</span>
              </label>
              <select
                name="clinics"
                className="form-control"
                value={formData.clinics}
                onChange={handleChange}
                required
              >
                <option value="">Select Clinic</option>
                {clinicList.map((clinic) => (
                  <option key={clinic._id} value={clinic._id}>
                    {clinic._id}
                  </option>
                ))}
              </select>
            </div>
            <div className="mb-3 col-md-4">
              <label>
                Gender<span className="error">*</span>
              </label>
              <select
                name="gender"
                className="form-control"
                value={formData.gender}
                onChange={handleChange}
              >
                <option value="MALE">MALE</option>
                <option value="FEMALE">FEMALE</option>
              </select>
            </div>
          </div>
          <div className="d-flex justify-content-end">
            <Button
              text={loading ? "Saving..." : "Add"}
              className="btn btn-primary"
              type="submit"
            />
          </div>
        </form>
      </div>
    </div>
  );
};
export default AddAdmin;